const state = {
    loading: true,
    show_landscape_error: false,

    loading: true,
    percentage_load: null,
    started: false,
}

const mutations = {
    updateLandscapeOverlay: (state, payload) => {
        state.show_landscape_error = payload.show_landscape_error;
    },
    updatePercentageLoad: (state, payload) => state.percentage_load = payload.percentage_load,
    updateStarted: (state, payload) => state.started = payload.started,
    updateLoading: (state, payload) => state.loading = payload.loading,
}

const actions = {
    asyncUpdateLandscapeOverlay ( {commit}, payload ) {
        commit('updateLandscapeOverlay', payload)
    },
    asyncUpdateStarted ( {commit}, payload ) {
        commit('updateStarted', payload)
    },
    asyncUpdateLoading ( {commit}, payload ) {
        commit('updateLoading', payload)
    },
    asyncUpdatePercentageLoad ( {commit}, payload ) {
        commit('updatePercentageLoad', payload)
    },
}

const getters = {
    overlays: state => {
        return state
    },
    percentageLoad: state => {
        return state.percentage_load
    },
    loading: state => {
        return state.loading
    },
    started: state => {
        return state.started
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
